import { NumberInput, SimpleForm, required, TextInput } from "react-admin";
import React from "react";
import { Toolbar } from "ra-friendsofbabba";

const Form = ({ classes, ...props }) => {
  return (
    <SimpleForm
      {...props}
      toolbar={
        <Toolbar
          backTab={1}
          backReference="executive-projects"
          backReferenceTarget="executive_project_id"
        />
      }
    >
      <NumberInput source="amount" validate={required()} />
      <TextInput
        fullWidth
        multiline
        source="description"
        validate={required()}
        maxLength={500}
      />
    </SimpleForm>
  );
};

export default Form;
